import React from "react";
import Button from "../Buttons/Button";

const Chip = ({
  variant = "contained", // contained, outlined, text
  size = "md", //xs, xs-sm, sm, md, lg, xl
  color = "info", // primary, warning, success, danger, info, black, white, invoiced,leave,draft
  icon,
  iconPosition = "before",
  disabled = false,
  label,
  onDelete,
  className = "",
  onClick
}) => {
  // Size styles for padding, font size, and icon size
  const sizeStyles = {
    xs: "px-1 py-0.5 text-[10px] rounded",
    "xs-sm": "px-1 py-0.5 text-[10px] rounded",
    sm: "px-1 py-0.5 text-[12px] rounded",
    md: "px-2 py-0.5 text-[14px] rounded-md",
    lg: "px-3 py-1 text-[16px] rounded-md",
    xl: "px-4 py-1 text-[18px] rounded-md",
  };

  const iconSizeStyles = {
    xs: "!text-[12px]",
    "xs-sm": "!text-[14px]",
    sm: "!text-[16px]",
    md: "!text-[18px]",
    lg: "!text-[20px]",
    xl: "!text-[22px]",
  };

  // Color styles based on variant
  const colors = {
    primary: {
      contained: "bg-primary-50 border border-primary-50",
      outlined: "border border-primary text-primary",
      text: "text-primary",
    },
    invoiced: {
      contained: "bg-invoiced-50 border border-invoiced-50",
      outlined: "border border-invoiced text-invoiced",
      text: "text-invoiced",
    },
    leave: {
      contained: "bg-leave-50 border border-leave-50",
      outlined: "border border-leave text-leave",
      text: "text-leave",
    },
    draft: {
      contained: "bg-draft-50 border border-draft-50",
      outlined: "border border-draft text-draft",
      text: "text-draft",
    },
    warning: {
      contained: "bg-warning-50 border border-warning-50",
      outlined: "border border-warning text-warning",
      text: "text-warning",
    },
    success: {
      contained: "bg-success-50 border border-success-50",
      outlined: "border border-success text-success",
      text: "text-success",
    },
    danger: {
      contained: "bg-danger-50 border border-danger-50",
      outlined: "border border-danger text-danger",
      text: "text-danger",
    },
    info: {
      contained: "bg-info-50 border border-info-50",
      outlined: "border border-info text-info",
      text: "text-info",
    },
    black: {
      contained: "bg-black text-white border border-black",
      outlined: "border border-black text-black",
      text: "text-black",
    },
    white: {
      contained: "bg-white text-black border border-neutrals-50",
      outlined: "border border-gray-300 text-gray-700",
      text: "text-gray-700",
    },
  };

  // Disabled styles
  const disabledStyles = "opacity-50 cursor-not-allowed";

  return (
    <div
      onClick={!disabled ? onClick : undefined}
      className={`
        inline-flex items-center  transition-all duration-200 leading-none
        ${sizeStyles[size]}
        ${colors[color]?.[variant]}
       
        ${disabled ? disabledStyles : ""}
        ${className}
      `}
    >
      {icon && iconPosition === "before" && (
        <span
          className={`material-symbols-rounded mr-1 ${iconSizeStyles[size]}`}
        >
          {icon}
        </span>
      )}

      <span>{label}</span>

      {icon && iconPosition === "after" && (
        <span
          className={`material-symbols-rounded ml-1 ${iconSizeStyles[size]}`}
        >
          {icon}
        </span>
      )}

      {onDelete && (
        <>
          <div className="ml-2" />
          <Button
            type="icon"
            variant="text"
            icon={"close"}
            size="xs"
            color={color}
            onClick={!disabled ? onDelete : undefined}
          />
        </>
        // <span
        //   className={`material-symbols-rounded ml-1 ${iconSizeStyles[size]} cursor-pointer`}
        //   onClick={!disabled ? onDelete : undefined}
        // >
        //   close
        // </span>
      )}
    </div>
  );
};

export default Chip;
